module.exports = __webpack_public_path__ + "static/media/magnifying_glass_small_outline.60179bea.svg";